import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { EtablissementDTO } from '@logaia_users/logaia-dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SiretService {
  private readonly baseUrl = `${environment.apiUrl.siret}Siret/`;
  private readonly http: HttpClient = inject(HttpClient);
  private readonly SIRET_KEY = 'siret_token';

  getTokenFromLocal(): string | null {
    return localStorage.getItem(this.SIRET_KEY);
  }

  setTokenLocal(token: string): void {
    localStorage.setItem(this.SIRET_KEY, token);
  }

  searchEtablissementFromSiret(siret: string): Observable<EtablissementDTO> {
    return this.http.get<EtablissementDTO>(`${this.baseUrl}${siret}`);
  }

  searchEtablissementFromSiren(siren: string): Observable<EtablissementDTO[]> {
    return this.http.get<EtablissementDTO[]>(`${this.baseUrl}siren/${siren}`);
  }
}
